/**
 * @voltxampere/ui — TDA2030 audio amplifier (Sprint 45-2, placeholder)
 *
 * Reference: ST TDA2030A — Pentawatt-5 (TO-220-5). Orta güç tek-
 * kanal Hi-Fi audio amp. V_supply ±6 to ±18 V (single-supply
 * 12-36 V), 18 W output @ 4 Ω (THD 0.5%), gain 30-100 dB
 * (eksternal feedback ile), GBW ~3 MHz. Klasik DIY hi-fi guitar
 * amp + small bookshelf speaker + 2.1 subwoofer.
 *
 *   Default mapping → opamp schemaType:
 *     openLoopGain = 1e5       (typical Hi-Fi op-amp)
 *     poleFrequency = 30       (3 MHz / 1e5 GBW estimate)
 *     saturationVoltage = 14   (V_supply ±18V için close-to-rail)
 *
 * Engine zero-diff invariant honored — canonical `opamp` engine
 * type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { opAmp } from "../op-amp.js";
export const audioTda2030 = {
    id: "tda2030",
    nameTr: "TDA2030A (Audio Amp 18W, TO-220-5, placeholder)",
    nameEn: "TDA2030A (Audio Amp 18W, TO-220-5, placeholder)",
    shortcut: "U",
    category: "active",
    viewBox: opAmp.viewBox,
    terminals: opAmp.terminals,
    defaultLabel: "U",
    defaultValue: "TDA2030A",
    schemaType: "opamp",
    defaultParams: { openLoopGain: 1e5, poleFrequency: 30, saturationVoltage: 14 },
    renderSVG: () => opAmp.renderSVG(),
};
//# sourceMappingURL=audio-tda2030.js.map